import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { Card, CardContent, CardHeader, Grid, IconButton, Stack } from '@mui/material'
import request, { gql } from 'graphql-request'
import BASEURL from '../../Utils/Baseurl'
import { useLocation, useNavigate } from 'react-router-dom'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MaterialTypography from '../../../components/MaterialTypography'
import MaterialDataGrid from '../../../components/MaterialDataGrid'
import MaterialInput from '../../../components/MaterialInput'
import { useLoading } from '../../../context/loading'

function IncrementData() {

const location = useLocation();
const employee_id = location?.state?.id || null;
const navigate = useNavigate();
const { circleLoading, setCirleLoading } = useLoading();
console.log(employee_id,"employee_id");

const [employeeDetails, setEmployeeDetails] = useState({
  empid: "",
  name: "",
  branch: "",

  empidStatus: "unchecked",
  nameStatus: "unchecked",
  branchStatus: "unchecked",
});


const [rows, setRows] = useState([]);

const columns = [
  {
    field: "basicAmount",
    headerName: "Basic Amount",
    flex: 1,
    disableColumnMenu: true,
    editable: false,
    sortable: true
  },
  {
    field: "daAmount",
    headerName: "DA Amount",
    flex: 1,
    disableColumnMenu: true,
    editable: false,
    sortable: true
  },
  {
    field: "mealsAmountPerDay",
    headerName: "Meals Amount/ Day",
    flex: 1.3,
    disableColumnMenu: true,
    editable: false,
    sortable: true
  },
  {
    field: "otAmountPerHour",
    headerName: "OT Amount/ Hour",
    flex: 1.3,
    disableColumnMenu: true,
    editable: false,
    sortable: true
  },
  {
    field: "hraAmount",
    headerName: "Hra Amount",
    flex: 1.3,
    disableColumnMenu: true,
    editable: false,
    sortable: true
  },
  {
    field: "shiftPaisa",
    headerName: "Shift Paisa",
    flex: 1,
    disableColumnMenu: true,
    editable: false,
    sortable: true
  },
  {
    field: "attendanceAmount",
    headerName: "Attendance Amount",
    flex: 1.3,
    disableColumnMenu: true,
    editable: false,
    sortable: true
  },
  {
    field: "busFare",
    headerName: "Bus fare",
    flex: 0.8,
    disableColumnMenu: true,
    editable: false,
    sortable: true
  },
  {
    field: "createdAt",
    headerName: "Created At",
    flex: 1,
    disableColumnMenu: true,
    editable: false,
    sortable: true
  }
];
const query = gql`
  query get_increment_by_employee_id($employee_id: String!){
  getIncrementByEmployeeId(employeeId: $employee_id){
   data{
      employee{
        email
        empid
        firstName
        lastName
        category
        employeeType
        branch     
      }
        basicAmount
        daAmount 
        mealsAmountPerDay 
        otAmountPerHour 
        shiftPaisa 
        attendanceAmount 
        hraAmount
        busFare
        createdAt
    }
    message
    success
    error
  }
}`;


useEffect(() => {
  if (employee_id) {
    const fetchIncrementData = async () => {
      setCirleLoading(true);
      try {
        const response = await request(BASEURL, query, { employee_id });

        if (response?.getIncrementByEmployeeId?.data?.length > 0) {
          const employee = response.getIncrementByEmployeeId.data[0].employee;
        
          setEmployeeDetails({
            empid: employee.empid,
            name: `${employee.firstName} ${employee.lastName}`,
            branch: employee.branch,

            empidStatus: employee.empid ? "success" : "unchecked",
            nameStatus: `${employee.firstName} ${employee.lastName}` ? "success" : "unchecked",
            branchStatus: employee.branch ? "success" : "unchecked",
            
          });
        
          const formattedData = response.getIncrementByEmployeeId.data.map((item, index) => ({
            id: index + 1,
            basicAmount: item.basicAmount,
            daAmount: item.daAmount,
            mealsAmountPerDay: item.mealsAmountPerDay,
            otAmountPerHour: item.otAmountPerHour,
            shiftPaisa: item.shiftPaisa,
            attendanceAmount: item.attendanceAmount,
            hraAmount:item.hraAmount,
            busFare: item.busFare,
            createdAt: item.createdAt.slice(0, 10) 
            
          }));
        
          setRows(formattedData);
        }
        
      } catch (error) {
        console.error("Error fetching data", error);
      }
      finally{
        setCirleLoading(false);
      }
    };

    fetchIncrementData();
  }
}, [employee_id]);

  return (
    
    <DashboardLayout>
      <Card>
        <CardHeader title={(
          <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          >
            <Stack direction="row" spacing={0}>
              <IconButton
                onClick={() => {
                  navigate("/increment");
                }}
                sx={{ mr: 1, mt: -0.7 }}
              >
                <ArrowBackIcon />
              </IconButton>{" "}
                <MaterialTypography variant="h5" fontWeight="medium">
                    Increment Data
                </MaterialTypography>
            </Stack>

          </Stack>
        )}>
          
        </CardHeader>
        <CardContent>
        <MaterialTypography
        component="label"
        variant="body2"
        fontWeight="bold"
        >
            Employee's Data
        </MaterialTypography>

        <div style={{ border: "1px solid black", padding: "1%", borderRadius: "10px"}}>
         <Grid container spacing={1}>

            <Grid item xs={12} sm={4} lg={4}>
              <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold">
                Employee ID
              </MaterialTypography>
              <MaterialInput
              value={employeeDetails.empid}
              success= {employeeDetails.empidStatus === "success" ? true : false}
              disabled
              />
            </Grid>
            <Grid item xs={12} sm={4} lg={4}>
              <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold">
                Employee Name
              </MaterialTypography>
              <MaterialInput
              value={employeeDetails.name} 
              success= {employeeDetails.nameStatus === "success" ? true : false}
              disabled
              />
            </Grid>
            <Grid item xs={12} sm={4} lg={4}>
              <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold">
                Branch
              </MaterialTypography>
              <MaterialInput
              value={employeeDetails.branch} 
              success= {employeeDetails.branchStatus === "success" ? true : false}
              disabled
              />
            </Grid>
         
        </Grid>
        </div>
       </CardContent>
       <CardContent>
        <MaterialTypography
        component="label"
        variant="body2"
        fontWeight="bold"
        >
            Increment Data
        </MaterialTypography>
        <MaterialDataGrid
          rows= {rows}
          columns= {columns}
          localeText={{
              noRowsLabel: (
                  <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                      <MaterialTypography variant="body2" fontWeight="medium" color="text">
                          No Increment Data found
                      </MaterialTypography>
                      <MaterialTypography variant="caption" color="text">
                          You have not yet added any Increment details.
                      </MaterialTypography>
                  </Stack>
              )
          }}
        />
        </CardContent>
        
      </Card>
        
    </DashboardLayout>
  )
}

export default IncrementData